'use client';

import {
    Accordion,
    AccordionBody,
    AccordionHeader,
    AccordionItem,
    Align,
    DirectionEnum,
    FlexBox,
    Justify,
    Spacer,
    SpacerSize,
    Text,
    TextLevels,
    TypographyBold,
} from '@bytel/trilogy-react';

import { EasyTradeInResult } from '@app-types/easy-trade-in';

import { InlinePrice } from '@components/inline-price';

type TicketEasyTradeInProps = {
    result: EasyTradeInResult;
    returnedPhoneName: string | undefined;
};

export function TicketEasyTradeIn({ result, returnedPhoneName }: Readonly<TicketEasyTradeInProps>) {
    return (
        <>
            <Spacer size={SpacerSize.FIVE} />
            <Accordion>
                <AccordionItem className='has-background-main-fade'>
                    <AccordionHeader>
                        <FlexBox
                            direction={DirectionEnum.ROW}
                            gap={1}
                            justify={Justify.SPACE_BETWEEN}
                            className='is-fullwidth'
                            align={Align.CENTER}
                        >
                            <div>
                                <Text typo={TypographyBold.TEXT_WEIGHT_SEMIBOLD} level={TextLevels.TWO} marginless>
                                    Crédit restant à payer
                                </Text>
                                <Text typo={TypographyBold.TEXT_WEIGHT_NORMAL} level={TextLevels.THREE} marginless>
                                    Prélevé par Younited
                                </Text>
                            </div>

                            <InlinePrice level={TextLevels.THREE} amount={result.remainingCredit} />
                        </FlexBox>
                    </AccordionHeader>
                    <AccordionBody>
                        <FlexBox justify={Justify.SPACE_BETWEEN}>
                            <Text typo={TypographyBold.TEXT_WEIGHT_NORMAL} level={TextLevels.THREE} marginless>
                                {returnedPhoneName ?? 'Téléphone précédent'}
                            </Text>
                            <InlinePrice level={TextLevels.THREE} amount={result.remainingCreditTerminal} />
                        </FlexBox>
                        {result.creditAccessories > 0 && (
                            <FlexBox justify={Justify.SPACE_BETWEEN}>
                                <Text typo={TypographyBold.TEXT_WEIGHT_NORMAL} level={TextLevels.THREE} marginless>
                                    Accessoires précédents
                                </Text>
                                <InlinePrice level={TextLevels.THREE} amount={result.creditAccessories} />
                            </FlexBox>
                        )}
                    </AccordionBody>
                </AccordionItem>
            </Accordion>
        </>
    );
}
